import React from 'react';
import PropTypes from 'prop-types';
import {QueryRenderer, graphql} from 'react-relay';
import modernEnvironment from '../../lib/RelayUtils';
// Модальное окно
import Dialog from 'material-ui/Dialog';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
// Иконки
import ContentAdd from 'material-ui/svg-icons/content/add';
import Photo from 'material-ui/svg-icons/image/photo';
import Icon from '../ui/icon/icon';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
// Редактирование видео-файла
import MediaMetaInfo from './MediaMetaInfo';
// Информация о количестве загружаемых файлов в фоне
import BackgroundLoadInfo from './BackgroundLoadInfo';

// Upload File
import LoadItem from './LoadItem';
// UI
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import {closeBtn, modalStyle, tooltipStyle, btnStyle} from './modal-style';
import '../ui/form.css';
import '../ui/upload-window.css';

const pageBody = document.getElementsByTagName('body')[0];

const propTypes = {
    insertAfterUpload: PropTypes.bool,
    open: PropTypes.bool,
    // Загрузка нескольких файлов
    multiple: PropTypes.bool
};

let countLoadItem = 0;

class MediaGalleryItem extends React.Component {

    constructor() {
        super();
        this.fileStack = {};
    }

    componentWillMount() {
        let loadItemText;
        switch (this.props.type) {
        case 'video':
            loadItemText = 'Добавить видео';
            break;
        case 'image':
            loadItemText = 'Добавить изображение';
            break;
        default:
            loadItemText = 'Добавить элемент';
            break;
        }
        this.setState({
            openEditWindow: false,
            metaInfo: null,
            modalShow: {display: 'block'},
            open: false,
            fileStack: [],
            popupTitle: 'Загрузка',
            percent: {},
            originalName: '',
            progressBarShow: {},
            loadItemText: loadItemText,
            backgroundStatus: '',
            backgroundText: '',
            countUpload: 0,
            countLoading: 0,
            type: this.props.type,
            orientationShow: this.props.orientationShow || window.location.href.indexOf('person') !== -1,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.hideModalWindow) {
            this.setState({
                modalShow: {display: 'block'}
            });
            pageBody.style.overflow = 'hidden';
        }
        if (nextProps.open === this.state.open) {
            return;
        }
        this.setState({open: nextProps.open});
    }

    /**
     * Замена ключевого поля с имени файла на его id
     * @param {object} params содержит имя файла и его id
     */
    changeKeyField = (params) => {
        // замена в общем массиве
        if (this.fileStack.hasOwnProperty(params.fileName)) {
            this.fileStack[params.id] = this.fileStack[params.fileName];
            delete this.fileStack[params.fileName];
        }
    };

    /**
     * Скрыть окно и продолжить загрузки в фоне
     */
    handleClose = () => {
        this.setState({
            modalShow: {display: 'none'}
        });
        pageBody.style.overflow = 'auto';
        this.props.getOpenState({hideModalWindow: true, open: true});
    };

    /**
     * Закрытие окна и остановка/удаление всех загрузок
     */
    clearAndClose = () => {
        const component = this;
        this.props.getOpenState({open: false});
        this.fileStack = {};
        const loadItemText = this.props.type === 'video' ? 'Добавить видео' : 'Добавить изображение';
        component.setState({
            fileStack: [],
            open: false,
            loadItemText,
            backgroundStatus: '',
            backgroundText: ''
        });
    };

    /**
     * Обработка загрузки файлов.
     * @param e
     */
    onClickUpload = (e) => {
        const currentListLoader = this.state.fileStack;
        for (const key in e.target.files) {
            if (e.target.files.hasOwnProperty(key)) {
                const count = this.state.countUpload + 1;
                this.fileStack[e.target.files[key].name] = {};
                this.fileStack[e.target.files[key].name] = e.target.files[key];
                this.fileStack[e.target.files[key].name].meta = null;
                currentListLoader.push(e.target.files[key]);
                this.setState({countUpload: count});
            }
        }
        let loadItemText;
        switch (this.props.type) {
        case 'video':
            loadItemText = 'Добавить еще видео';
            break;
        case 'image':
            loadItemText = 'Добавить еще изображение';
            break;
        default:
            loadItemText = 'Добавить еще элемент';
            break;
        }
        this.setState({
            fileStack: currentListLoader,
            loadItemText,
            backgroundStatus: 'upload',
            popupTitle: 'Загрузка',
        });
    };

    renderModalWindow = () => {
        return (
            <QueryRenderer
                environment={modernEnvironment}
                query={graphql`
                        query MediaGalleryItem_Query{
                          viewer{
                            ...TopicSelector_viewer
                          }
                        }
                    `}
                render={({error, props}) => {
                    if (error) {
                        return (<div>{error.message}</div>)
                    }
                    if (props) {
                        return <MediaMetaInfo
                            open={this.state.openEditWindow}
                            viewer={props}
                            setInfo={this.state.metaInfo}
                            type={this.state.type}
                            getOpenState={(state) => {
                                this.setState({openEditWindow: state.open});
                            }}
                            sendMediaState={() => {
                            }}
                        />;
                    }
                    return (<div/>);
                }}
            />
        )
    };

    updateFileInfo = fileInfo => {
        const count = this.state.countUpload - 1;
        this.setState({countUpload: count});
        if (fileInfo.status === 'error') {
            this.setState({
                backgroundStatus: 'error',
                backgroundText: 'Ошибка!',
                popupTitle: 'Ошибка',
            });
            delete this.fileStack[fileInfo.originalName];
            return;
        }
        if (this.props.insertAfterUpload) {
            this.props.insertItem(fileInfo);
        }
        this.fileStack[fileInfo.id].newName = fileInfo.filename;
        this.props.getMediaState(true);
        if (this.state.countUpload <= 0) {
            this.setState({
                backgroundStatus: 'done',
                backgroundText: '',
                popupTitle: 'Загрузка',
            })
        }
    };

    /**
     * Открытие окна для редактирование мета-информации
     * @param data
     */
    editMetaInfo = data => {
        const meta = this.fileStack[data.id].meta || {};
        const mediaType = data.type ? data.type : 'video';
        meta.type = mediaType;
        meta.filename = data.filename;
        meta.id = data.id;
        this.setState({
            metaInfo: meta,
            type: mediaType,
            openEditWindow: true,
        });
    };

    render() {
        let acceptFile;
        switch (this.state.type) {
        case 'video':
            acceptFile = 'video/mp4';
            break;
        case 'image':
            acceptFile = 'image/*';
            break;
        default:
            acceptFile = 'video/mp4,image/*';
            break;
        }
        return (
            <div>
                <BackgroundLoadInfo
                    status={this.state.backgroundStatus}
                    text={this.state.backgroundText}
                />
                <Dialog
                    title={
                        <div style={{position: 'relative'}}>
                            {this.state.popupTitle}
                            <IconButton
                                style={{
                                    ...closeBtn,
                                    marginTop: '-12px',
                                    marginRight: '-19px'
                                }}
                                onClick={this.handleClose}
                                tooltip={this.state.countLoading ? 'Закрыть окно и продолжить загрузку' : '' }
                                tooltipPosition='top-center'
                                tooltipStyles={tooltipStyle}
                            >
                                <CloseIcon hoverColor='#542376'/>
                            </IconButton>
                        </div>
                    }
                    // actions={actions}
                    actions={[
                        <FlatButton
                            label={this.state.countLoading ? "Отменить все" : "Готово"}
                            backgroundColor={this.state.countLoading ? "#d0021b" : "#46BC98"}
                            hoverColor='#542376'
                            style={
                                this.state.countLoading ?
                                    {
                                        ...btnStyle,
                                        width: 190,
                                    } :
                                    {
                                        ...btnStyle,
                                        width: 115
                                    }
                            }
                            labelStyle={{fontWeight: 'normal', display: 'block', marginTop: 0}}
                            onClick={() => {
                                if (this.state.countLoading) {
                                    this.clearAndClose();
                                } else {
                                    this.handleClose();
                                }
                            }}/>
                    ]}
                    modal={false}
                    open={this.state.open}
                    style={this.state.modalShow}
                    contentStyle={modalStyle.main}
                    titleStyle={modalStyle.title}
                    bodyStyle={modalStyle.body}
                    actionsContainerStyle={modalStyle.footer}
                    overlayStyle={modalStyle.overlay}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}
                >
                    {this.state.openEditWindow && this.renderModalWindow()}
                    {this.state.fileStack.map((item, index) => {
                        return <LoadItem
                            key={index}
                            file={item}
                            getFileId={id => {
                                this.changeKeyField(id);
                            }}
                            sendLoadingStatus={(status) => {
                                if (status === 'loading') {
                                    countLoadItem += 1;
                                }
                                if (status === 'done') {
                                    countLoadItem -= 1;
                                }
                                this.setState({countLoading: countLoadItem})
                            }}
                            sendUploadStatus={this.updateFileInfo.bind(this)}
                            editMetaFile={this.editMetaInfo.bind(this)}
                            orientation={this.state.orientation}
                        />;
                    })}
                    <footer>
                        <header style={{marginTop: 38}}>
                            {this.state.loadItemText}
                        </header>
                        <section style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '6px 2px 1px 0',
                            borderBottom: 'solid 1px #E0E0E0'
                        }}>
                            <ContentAdd/>
                            <IconButton
                                containerElement='label'
                                style={{maxWidth: 12, height: 42, padding: 9}}
                                className='btn__hover_empty'
                            >
                                {this.props.type === 'video' && <Icon icon="video"/>}
                                {this.props.type !== 'video' && <Photo color='#46bc98' hoverColor='#542376'/>}
                                <input
                                    id="input-upload-item"
                                    type="file"
                                    ref={(c) => {
                                        this.input = c;
                                    }}
                                    multiple={this.props.multiple}
                                    accept={acceptFile}
                                    style={{display: 'none'}}
                                    onChange={this.onClickUpload}
                                />
                            </IconButton>
                        </section>
                        {this.state.orientationShow && <div style={{margin: '20px 0 5px'}}>
                            <header style={{margin: '0 0 10px'}}>Метод обрезания изображения:</header>
                            <RadioButtonGroup
                                name="orientation"
                                defaultSelected="default"
                                onChange={(e, value) => {
                                    this.setState({ orientation: value })
                                }}
                            >
                                <RadioButton
                                    value="default"
                                    label="Стандартный"
                                    style={{marginBottom: 5}}
                                />
                                <RadioButton
                                    value="vertical"
                                    label="Вертикальный"
                                    style={{marginBottom: 5}}
                                />
                                <RadioButton
                                    value="square"
                                    label="Квадратный"
                                    style={{marginBottom: 5}}
                                />
                            </RadioButtonGroup>
                        </div>}
                    </footer>
                </Dialog>
            </div>
        );
    }
}

MediaGalleryItem.propsTypes = propTypes;
MediaGalleryItem.defaultProps = {
    multiple: true,
    insertAfterUpload: false
};

export default MediaGalleryItem;



// WEBPACK FOOTER //
// src/components/media/MediaGalleryItem.js